import { baseApi } from 'segments/api/baseApi';

import { adaptCoachesBooking } from '../utils/adapter';
import { transformCtCoachBkBody } from '../utils/transformer';

import type {
  CoachesBooking,
  CreateCoachBooking,
  DeleteCoachBooking,
  GetCoachesBooking,
} from './types';

export const api = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCoachesBooking: builder.query<CoachesBooking, GetCoachesBooking>({
      query: (params) => ({
        url: '/admin/coach_bookings/table',
        method: 'GET',
        params: {
          'date_from': params.dateFrom,
          'date_to': params.dateTo
        }
      }),
      transformResponse: adaptCoachesBooking,
      providesTags: ['CoachesBooking'],
      keepUnusedDataFor: 1,
    }),
    deleteCoachBooking: builder.mutation<void, DeleteCoachBooking>({
      query: (params) => ({
        url: '/admin/coach_bookings/',
        method: 'DELETE',
        params: {
          'booking_id': params.bookingId,
          ...(params.deleteUntil && { 'delete_until': params.deleteUntil })
        }
      }),
      invalidatesTags: ['CoachesBooking']
    }),
    createCoachBooking: builder.mutation<unknown, CreateCoachBooking>({
      query: (formData: CreateCoachBooking) => ({
        url: '/admin/coach_bookings/',
        method: 'POST',
        body: transformCtCoachBkBody(formData),
      }),
      invalidatesTags: ['CoachesBooking']
    }),
  }),
});

export const {
  useCreateCoachBookingMutation,
  useDeleteCoachBookingMutation,
  useGetCoachesBookingQuery
} = api;
